import React from "react";
import { Card } from "react-bootstrap";
import { ThreeDots } from "react-loader-spinner";

function Loader() {
  return (
    <ThreeDots
      visible={true}
      height="50"
      width="50"
      color="#dae3f3"
      radius="5"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClass="loader"
    />
  );
}

export default Loader;
